import { render, staticRenderFns } from "./ConfirmDelivery.vue?vue&type=template&id=2c1a06ff&scoped=true"
import script from "./ConfirmDelivery.vue?vue&type=script&lang=js"
export * from "./ConfirmDelivery.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDelivery.vue?vue&type=style&index=0&id=2c1a06ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1a06ff",
  null
  
)

export default component.exports